import {Entity} from '@s-ui/domain'

import {IdSharedValueObject} from '../../shared/ValueObjects/IdSharedValueObject.js'

export class LocationEntity extends Entity {
  #id
  #name

  constructor({id, name}) {
    super()
    this.#id = id
    this.#name = name
  }

  static empty() {
    return new LocationEntity({id: IdSharedValueObject.empty()})
  }

  static isValid({id}) {
    return IdSharedValueObject.safeValidate({id})
  }

  static createFromLiterals({id, name}) {
    if (!LocationEntity.isValid({id})) return LocationEntity.empty()
    return new LocationEntity({id: IdSharedValueObject.createFromPrimitives({id}), name})
  }

  get id() {
    return this.#id.value
  }

  get name() {
    return this.#name
  }

  get value() {
    return {
      id: this.id,
      name: this.name
    }
  }

  isEmpty() {
    return this.#id.isEmpty()
  }
}
